import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroCombo } from './filtro-combo';
import { Safe } from './safe';
import { SimNaoPipe } from './sim-nao.pipe';
import { SituacaoCadastralPipe } from './situacao-cadastral.pipe';



@NgModule({
  declarations: [FiltroCombo, Safe, SimNaoPipe, SituacaoCadastralPipe],
  imports: [
    CommonModule
  ],
  exports: [FiltroCombo, Safe, SimNaoPipe, SituacaoCadastralPipe]
})
export class PipesModule { }
